import { getPasswordStrength } from '../../utils/passwordValidation.js'

/**
 * Password Strength Indicator Component
 * 
 * Displays password strength with visual feedback
 */
const PasswordStrengthIndicator = ({ password }) => {
  if (!password) {
    return null
  }

  const strength = getPasswordStrength(password)

  const getColor = () => {
    switch (strength.level) {
      case 'strong':
        return '#28a745' // green
      case 'medium':
        return '#ffc107' // yellow
      case 'weak':
        return '#dc3545' // red
      default:
        return '#6c757d' // gray
    }
  }

  const getLabel = () => {
    switch (strength.level) {
      case 'strong':
        return 'Fort'
      case 'medium':
        return 'Moyen'
      case 'weak':
        return 'Faible'
      default:
        return ''
    }
  }

  return (
    <div className="mt-2">
      <div className="flex items-center gap-2 mb-2">
        <div className="flex-1 bg-gray-200 rounded-full h-2">
          <div
            className="h-2 rounded-full transition-all duration-300"
            style={{
              width: `${(strength.score / 5) * 100}%`,
              backgroundColor: getColor()
            }}
          />
        </div>
        <span
          className="text-sm font-medium"
          style={{ color: getColor() }}
        >
          {getLabel()}
        </span>
      </div>
      
      {strength.feedback && strength.feedback.length > 0 && (
        <ul className="text-xs text-gray-600 space-y-1">
          {strength.feedback.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="mr-2">
                {strength.level === 'strong' ? '✓' : '•'}
              </span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default PasswordStrengthIndicator

